module.exports = __webpack_public_path__ + "static/img/1.6f1b0a50.jpg";